import React from 'react';

/**
 * Elección entre las modalidades de un prompt oficial, con la CONSECUENCIA a la vista.
 *
 * Las mismas opciones aparecen hoy en la ficha del cliente ("Conectar tu IA") y en las dos
 * superficies de `/dashbo-mcp`, y en todas la pregunta es la misma: si el Project/GPT ya tiene
 * instrucciones propias, el bloque tiene que ser ADITIVO; si es nuevo, va el pack completo; y
 * donde el backend sembró el stub del conector, ese es el recomendado. Vive acá y no en
 * `ia_assistant/` porque ninguna de las pantallas es dueña del patrón.
 *
 * Por qué tarjetas con descripción y no un segmentado: la advertencia de "no se borra nada de lo
 * tuyo" tiene que leerse ANTES de elegir. Con el control a la derecha del título, esa consecuencia
 * quedaba adentro del bloque, o sea después de haber decidido.
 *
 * Los estilos (`.ia-instructions-option*`) viven en `sass/elements/_prompt-modality.scss`, a nivel
 * raíz y sin ancestro: anidados bajo `.ia-instructions` (donde nacieron) las cards de `/dashbo-mcp`
 * se quedaban sin estilos y los radios caían en el `@extend` global de `_forms.scss`. No volver a
 * anidarlos: una superficie nueva repetiría el bug en silencio.
 */
export function PromptModalityChoice({name, question, options, value, onChange}) {
    return (
        <div className="ia-instructions-choice">
            <p className="ia-instructions-question">{question}</p>
            <ul className="ia-instructions-options" role="radiogroup" aria-label={question}>
                {options.map((option) => {
                    const active = option.value === value;
                    return (
                        <li key={option.value}>
                            <label className={`ia-instructions-option ${active ? '-selected' : ''}`}>
                                <input
                                    type="radio"
                                    name={name}
                                    value={option.value}
                                    checked={active}
                                    onChange={() => onChange(option.value)}
                                />
                                <span className="ia-instructions-option-text">
                                    <strong className="ia-instructions-option-title">{option.title}</strong>
                                    <span className="ia-instructions-option-desc">{option.description}</span>
                                </span>
                            </label>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
